module.exports = __webpack_public_path__ + "static/media/feedback.a6560b33.png";